import React, { useRef } from "react";
import {
    Paging,
    Pager,
    FilterRow,
    ColumnChooser,
    Column,
    Lookup,
    Export,
    Button as ButtonGrid,
}
    from 'devextreme-react/data-grid';
import { DataGrid } from 'devextreme-react';
import { useDispatch, useSelector } from 'react-redux'
import { openDialog } from '../../store/cliente/clienteDialogReducer';
import { billDialogAction } from '../../store/bill/billDialogReducer';
import BlockHeader from '../../components/shared/BlockHeader';
import Title from "../../components/shared/Title";
import { store } from "../../services/store";
import Nuevo from "./Nuevo";
import * as NuevoSMS from "../../components/sms/Nuevo";
import * as NuevoBill from "../bills/Nuevo";
import { dataAccess, formatDate, resources } from '../../data/app';
import { createStore } from "../../utils/proxy";
import uri from "../../utils/uri";
import useAuthorization from "../../hooks/useAuthorization";
import { updateSmsDialog } from "../../store/sms/smsReducer";
import { getConfig, typesBill } from "../../data/bill";
import { padIdInfo } from "../../utils/common";

const Clients = props => {

    const { history } = props;
    const { appInfo } = useSelector(store => store);
    const { authorized } = useAuthorization([resources.clients, dataAccess.access]);

    let dataGrid = useRef();
    const title = "Clientes";
    const dispatch = useDispatch();

    const onToolbarPreparing = e => {

        e.toolbarOptions.items.unshift({
            location: 'after',
            widget: 'dxButton',
            options: {
                stylingMode: "outlined",
                type: 'default',
                icon: 'add',
                text: 'Agregar cliente',
                onClick: e => dispatch(openDialog({ open: true, id: 0 }))
            }
        });
    }

    const openThisDialog = id => dispatch(openDialog({ open: true, id }));

    const addMenuItems = (e) => {

        if (e.target == "content") {

            if (!e.items) e.items = [];

            if (e.rowIndex >= 0)
                e.items.push({

                    text: 'Editar',
                    icon: 'edit',
                    onItemClick: () => openThisDialog(e.row.data.id)

                }, {

                    text: 'Ver ficha',
                    icon: 'print',
                    onItemClick: () => history.push('/clinica/cliente/' + e.row.data.id)

                }, {

                    text: 'Crear factura',
                    icon: 'paste',
                    onItemClick: () => dispatch(billDialogAction({ clientId: e.row.data.id, open: true }))

                }, {

                    text: 'Crear cotización',
                    icon: 'paste',
                    onItemClick: () => { /*TODO*/ }

                }, {

                    text: 'Enviar sms',
                    icon: 'fas fa-mobile-alt',
                    onItemClick: () => {
                        dispatch(updateSmsDialog({ id: e.row.data.id, open: true }));
                    }
                });
        }
    }

    const onRowDblClick = (e) => navegateToFicha(e.data.id);

    const onClickBtn = (e) => {
        console.log(e);
        navegateToFicha(e.data.id);
        e.event.preventDefault();

    }

    const navegateToFicha = id => history.push('/clinica/cliente/' + id);

    const onSave = (params) => {
        dataGrid.current.instance.refresh();
    }

    const config = getConfig(typesBill.factura);

    const padId = padIdInfo(appInfo);

    return authorized(
        <div className="container">
            <Title title={title} />
            <BlockHeader title={title} />
            <Nuevo onSave={onSave} />
            <NuevoSMS.default />
            <NuevoBill.default onSave={() => { }} config={config} />
            <DataGrid
                ref={dataGrid}
                dataSource={store({ uri: uri.clients, remoteOperations: false })}
                selection={{ mode: 'single' }}
                showBorders={true}
                showRowLines={true}
                allowColumnResizing={true}
                columnHidingEnabled={true}
                allowColumnReordering={true}
                hoverStateEnabled={true}
                columnAutoWidth={true}
                rowAlternationEnabled={true}
                onToolbarPreparing={onToolbarPreparing}
                onContextMenuPreparing={addMenuItems}
                onRowDblClick={onRowDblClick}
                // remoteOperations={{
                //     paging: true,
                //     filtering: true
                // }}
            >
                <Pager allowedPageSizes={[10, 15, 30, 50]} showPageSizeSelector={true} showInfo={true} />
                <Paging defaultPageSize={15} />
                {/* <SearchPanel visible={true} width={250} /> */}
                <FilterRow visible={true} />
                <ColumnChooser enabled={true} />
                <Export enabled={true} fileName={title} allowExportSelectedData={true} />
                <Column type="buttons" width={70}>
                    <ButtonGrid name="modificar" icon="edit" onClick={e => openThisDialog(e.row.data.id)} />
                    {/* <ButtonGrid  hint="Clone" icon="copy"  onClick={onClickBtn} /> */}
                </Column>
                <Column dataField="id" caption="Expediente" width={90} format={(value) => padId(value)} />
                <Column dataField="fileNumber" caption="Oftalmosalus" width={90} />
                <Column dataField="identification" caption="identificacion" width={140} />
                <Column dataField="name" caption="Nombre" minWidth={180} />
                <Column dataField="lastName" caption="Apellidos" minWidth={140} />
                <Column dataField="birthdate" caption="Fecha de Nac" width={120} dataType="date" format={formatDate} />
                <Column dataField="sexId" caption="Sexo" visible={false}>
                    <Lookup disabled={true} dataSource={createStore({ name: 'sex' })} valueExpr="id" displayExpr="name" />
                </Column>
                <Column dataField="categoryId" caption="Categoria" visible={false}>
                    <Lookup disabled={true} dataSource={createStore({ name: 'category' })} valueExpr="id" displayExpr="name" />
                </Column>
                <Column dataField="phoneNumber" caption="Telefono" allowFiltering={false} visible={false} />
                <Column dataField="phoneNumberWork" caption="Telefono Trab" allowFiltering={false} visible={false} />
                <Column dataField="cellNumber" caption="Celular" allowFiltering={false} visible={false} />
                <Column dataField="email" caption="Correo" allowFiltering={false} visible={false} />
                <Column dataField="nacionalityId" caption="Nacionalidad" width={150}  visible={false} >
                    <Lookup disabled={true} dataSource={createStore({ name: 'country' })} valueExpr="id" displayExpr="name" />
                </Column>
                <Column dataField="departmentId" caption="Departamento" width={150}>
                    <Lookup disabled={true} dataSource={createStore({ name: 'department' })} valueExpr="id" displayExpr="name" />
                </Column>
                <Column dataField="cityId" caption="Ciudad" width={150} >
                    <Lookup disabled={true} dataSource={createStore({ name: 'city' })} valueExpr="id" displayExpr="name" />
                </Column>
                <Column dataField="professionId" caption="Prefesion" allowFiltering={false} width={120}>
                    <Lookup disabled={true} dataSource={createStore({ name: 'profession' })} valueExpr="id" displayExpr="name" />
                </Column>

            </DataGrid>
        </div>
    )


}


export default Clients;
